import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import money, { USD, format } from '../../lib/money';
import FormField from '../form-field';
import MoneyField from '../money-field';
import '../../css/share-info.spp.css';

class ShareInfoSpecifiedPerPerson extends Component {
  constructor(props) {
    super(props);
    this.onContributionChange = this.onContributionChange.bind(this);
  }

  onContributionChange(contribution) {
    this.props.onChange(contribution);
  }

  get minContribution() { return money(this.props.minContribution); }

  renderMinContribution() {
    if (!this.minContribution || this.minContribution.isZero()) return null;
    return (
      <span className="cool-grey ml-1">
        <FormattedMessage
          id="shareInfo.spp.minAmount"
          defaultMessage="Minimum {amount}"
          values={{amount: format(this.minContribution)}}
        />
      </span>
    );
  }

  render() {
    return (
      <div className="split-info specified-per-person">
        <div className="form-inline">
          <span className="h3 mr-1 mb-0">
            <FormattedMessage
              id="shareInfo.spp.label"
              defaultMessage="Your share is"
            />
          </span>
          <MoneyField
            name="allowedShareAmount"
            component={FormField}
            currency={this.props.currencyCode}
            onChange={this.onContributionChange}
          />
          {this.renderMinContribution()}
        </div>
      </div>
    );
  }
}

ShareInfoSpecifiedPerPerson.defaultProps = {
  currencyCode: USD,
  minContribution: null,
  onChange: () => {},
};

export default ShareInfoSpecifiedPerPerson;



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/share-info.spp.js